module.exports = __webpack_public_path__ + "img/06.46cd09b2.png";